// import React, { useState, useEffect } from 'react';
// import { FaTimes, FaHotel, FaExclamationCircle, FaCheckCircle, FaStar } from 'react-icons/fa';

// const HotelModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     hotelName: '',
//     location: '',
//     roomType: '',
//     checkIn: '',
//     checkOut: '',
//     guests: '',
//     price: '',
//     rating: '4'
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const pad = (num) => String(num).padStart(2, '0');
//   const formatDate = (date) => {
//     const d = new Date(date);
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
//   };

//   useEffect(() => {
//     if (editingItem) {
//       setFormData(editingItem);
//     } else {
//       const today = new Date();
//       const tomorrow = new Date(today);
//       tomorrow.setDate(today.getDate() + 1);
//       setFormData({
//         name: '',
//         hotelName: '',
//         location: '',
//         roomType: '',
//         checkIn: formatDate(today),
//         checkOut: formatDate(tomorrow),
//         guests: '1',
//         price: '',
//         rating: '4'
//       });
//     }
//     setErrors({});
//   }, [editingItem, isOpen]);

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) newErrors.name = 'Booking name is required';
//     if (!formData.hotelName.trim()) newErrors.hotelName = 'Hotel name is required';
//     if (!formData.location.trim()) newErrors.location = 'Location is required';
//     if (!formData.roomType) newErrors.roomType = 'Room type is required';
//     if (!formData.checkIn) newErrors.checkIn = 'Check-in date is required';
//     if (!formData.checkOut) newErrors.checkOut = 'Check-out date is required';
//     if (!formData.guests || formData.guests < 1) newErrors.guests = 'Number of guests is required';
//     if (!formData.price.trim()) newErrors.price = 'Price is required';

//     // Validate check-out is after check-in
//     if (formData.checkIn && formData.checkOut) {
//       const checkInDate = new Date(formData.checkIn);
//       const checkOutDate = new Date(formData.checkOut);
//       if (checkInDate >= checkOutDate) {
//         newErrors.checkOut = 'Check-out date must be after check-in date';
//       }
//     }

//     // Validate price format
//     if (formData.price && !/^\$?\d+(\.\d{2})?$/.test(formData.price)) {
//       newErrors.price = 'Please enter a valid price (e.g., $150 or 150)';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       // Simulate API call delay
//       await new Promise(resolve => setTimeout(resolve, 500));

//       onAdd(formData);
//       onClose();
//     } catch (error) {
//       console.error('Error submitting hotel:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 !m-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4 animate-fadeIn">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col transform transition-all duration-300 scale-100">
//         {/* Enhanced Header */}
//         <div className="bg-gradient-to-r from-green-600 via-emerald-700 to-teal-700 p-8 rounded-t-2xl relative overflow-hidden">
//           <div className="absolute inset-0 bg-black bg-opacity-10"></div>
//           <div className="relative flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm border border-white border-opacity-30">
//                 <FaHotel className="h-7 w-7 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-2xl font-display font-bold text-white">
//                   {editingItem ? 'Edit Hotel Reservation' : 'Add New Hotel'}
//                 </h3>
//                 <p className="text-green-100 text-lg">Complete hotel accommodation details</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="text-white hover:bg-white hover:bg-opacity-20 p-3 rounded-xl transition-all duration-200 hover:scale-105"
//             >
//               <FaTimes className="h-6 w-6" />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto bg-gray-50">
//           <form id="hotel-form" onSubmit={handleSubmit} className="p-8 space-y-8">
//             {/* Hotel Information Section */}
//             <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
//               <h4 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
//                 Hotel Information
//               </h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Location *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.location}
//                       onChange={(e) => handleInputChange('location', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all duration-200 ${errors.location ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                         }`}
//                       placeholder="e.g., Downtown Manhattan"
//                     />
//                     {errors.location && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.location && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.location}
//                     </p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Check-in Date *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={formData.checkIn}
//                       onChange={(e) => handleInputChange('checkIn', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all duration-200 ${errors.checkIn ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                         }`}
//                     />
//                     {errors.checkIn && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.checkIn && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.checkIn}
//                     </p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Check-out Date *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={formData.checkOut}
//                       onChange={(e) => handleInputChange('checkOut', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all duration-200 ${errors.checkOut ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                         }`}
//                     />
//                     {errors.checkOut && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.checkOut && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.checkOut}
//                     </p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Number of Guests *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       min="1"
//                       value={formData.guests}
//                       onChange={(e) => handleInputChange('guests', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all duration-200 ${errors.guests ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                         }`}
//                       placeholder="e.g., 2"
//                     />
//                     {errors.guests && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.guests && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.guests}
//                     </p>
//                   )}
//                 </div>


//               </div>
//             </div>
//           </form>
//         </div>
//         {/* Enhanced Footer */}
//         <div className="flex-shrink-0 bg-white border-t border-gray-200 p-8">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <button
//               type="submit"
//               form="hotel-form"
//               disabled={isSubmitting}
//               className="flex-1 bg-gradient-to-r from-green-600 via-emerald-700 to-teal-700 text-white py-4 px-8 rounded-xl font-semibold text-lg hover:from-green-700 hover:via-emerald-800 hover:to-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-lg flex items-center justify-center space-x-2"
//             >
//               {isSubmitting ? (
//                 <>
//                   <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
//                   <span>Processing...</span>
//                 </>
//               ) : (
//                 <>
//                   <FaCheckCircle className="h-5 w-5" />
//                   <span>{editingItem ? 'Update Hotel Reservation' : 'Add Hotel to Booking'}</span>
//                 </>
//               )}
//             </button>
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="flex-1 bg-gray-100 text-gray-700 py-4 px-8 rounded-xl font-semibold text-lg hover:bg-gray-200 transition-all duration-300 border border-gray-300 hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
//             >
//               <FaTimes className="h-5 w-5" />
//               <span>Cancel</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HotelModal;

import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaHotel,
  FaExclamationCircle,
  FaCheckCircle,
  FaStar,
} from "react-icons/fa";

const dummyHotels = [
  {
    id: 1,
    hotelName: "The Grand Palace",
    location: "Mumbai, India",
    roomType: "Deluxe Suite",
    price: "₹6500",
    rating: "5",
  },
  {
    id: 2,
    hotelName: "Sea View Resort",
    location: "Goa, India",
    roomType: "Ocean View Room",
    price: "₹4800",
    rating: "4",
  },
  {
    id: 3,
    hotelName: "Hilltop Inn",
    location: "Shimla, India",
    roomType: "Standard Room",
    price: "₹3200",
    rating: "3",
  },
];

const HotelModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    name: "",
    hotelName: "",
    location: "",
    roomType: "",
    checkIn: "",
    checkOut: "",
    guests: "1",
    price: "",
    rating: "4",
  });

  const [errors, setErrors] = useState({});
  const [showResults, setShowResults] = useState(false);

  const pad = (num) => String(num).padStart(2, "0");
  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData(editingItem);
    } else {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      setFormData({
        name: "",
        hotelName: "",
        location: "",
        roomType: "",
        checkIn: formatDate(today),
        checkOut: formatDate(tomorrow),
        guests: "1",
        price: "",
        rating: "4",
      });
    }
    setErrors({});
    setShowResults(false);
  }, [editingItem, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.location.trim())
      newErrors.location = "Location is required";
    if (!formData.checkIn) newErrors.checkIn = "Check-in date is required";
    if (!formData.checkOut) newErrors.checkOut = "Check-out date is required";

    if (formData.checkIn && formData.checkOut) {
      const checkInDate = new Date(formData.checkIn);
      const checkOutDate = new Date(formData.checkOut);
      if (checkInDate >= checkOutDate) {
        newErrors.checkOut = "Check-out date must be after check-in date";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setShowResults(true);
  };

  const handleSelectHotel = (hotel) => {
    const selectedHotel = {
      ...formData,
      hotelName: hotel.hotelName,
      location: hotel.location,
      roomType: hotel.roomType,
      price: hotel.price,
      rating: hotel.rating,
    };
    onAdd(selectedHotel);
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 via-emerald-700 to-teal-700 p-6 rounded-t-2xl flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <FaHotel className="text-white text-2xl" />
            <h3 className="text-xl font-bold text-white">
              {editingItem ? "Edit Hotel Reservation" : "Add Hotel Booking"}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-xl"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50">
          {!showResults ? (
            <form onSubmit={handleSearch} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Location */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Location *
                  </label>
                  <input
                    type="text"
                    value={formData.location}
                    onChange={(e) =>
                      handleInputChange("location", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.location
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="e.g., Goa, India"
                  />
                  {errors.location && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.location}
                    </p>
                  )}
                </div>

                {/* Check-in */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Check-in Date *
                  </label>
                  <input
                    type="date"
                    value={formData.checkIn}
                    onChange={(e) =>
                      handleInputChange("checkIn", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.checkIn
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.checkIn && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.checkIn}
                    </p>
                  )}
                </div>

                {/* Check-out */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Check-out Date *
                  </label>
                  <input
                    type="date"
                    value={formData.checkOut}
                    onChange={(e) =>
                      handleInputChange("checkOut", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.checkOut
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.checkOut && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.checkOut}
                    </p>
                  )}
                </div>

                {/* Guests */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Guests *
                  </label>
                  <input
                    type="number"
                    min="1"
                    value={formData.guests}
                    onChange={(e) =>
                      handleInputChange("guests", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.guests
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.guests && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.guests}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-green-700 transition"
                >
                  Search Hotels
                </button>
              </div>
            </form>
          ) : (
            <div>
              <h4 className="text-lg font-semibold mb-4">Available Hotels 🏨</h4>
              <div className="space-y-4">
                {dummyHotels.map((hotel) => (
                  <div
                    key={hotel.id}
                    className="flex justify-between items-center bg-white p-4 rounded-xl shadow"
                  >
                    <div>
                      <p className="font-semibold text-gray-800">
                        {hotel.hotelName}
                      </p>
                      <p className="text-gray-500">{hotel.location}</p>
                      <p className="text-gray-700">{hotel.roomType}</p>
                      <p className="flex items-center text-yellow-500">
                        {Array.from({ length: hotel.rating }).map((_, i) => (
                          <FaStar key={i} />
                        ))}
                      </p>
                      <p className="text-green-600 font-bold">{hotel.price}</p>
                    </div>
                    <button
                      onClick={() => handleSelectHotel(hotel)}
                      className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                    >
                      Select
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-white border-t p-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-100 px-6 py-2 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default HotelModal;
